"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DropdownContextProvider = exports.default = void 0;
const build_context_1 = __importDefault(require("~/components/jsx-helpers/build-context"));
const react_1 = require("react");
function useContextValue({ prefix } = { prefix: 'menulabel' }) {
    const [activeDropdown, setActiveDropdown] = (0, react_1.useState)({});
    const [submenuLabel, setSubmenuLabel] = (0, react_1.useState)();
    return {
        activeDropdown,
        setActiveDropdown,
        submenuLabel,
        setSubmenuLabel,
        prefix
    };
}
const { useContext, ContextProvider } = (0, build_context_1.default)({ useContextValue });
exports.default = useContext;
exports.DropdownContextProvider = ContextProvider;
